export const CITIES = {
  "1": "Islamabad",
  "3": "Karachi",
  "5": "Lahore",
  "7": "Peshawar",
  "9": "Rawalpindi",
  "11": "Abbottabad",
  "13": "Ahmedpur East",
  "15": "Arif Wala",
  "17": "Attock",
  "19": "Badin",
  "21": "Bahawalnagar",
  "13": "Bahawalpur",
  "25": "Bhakkar",
  "27": "Bhalwal",
  "29": "Burewala",
  "31": "Chakwal",
  "33": "Chaman",
  "35": "Charsadda",
  "37": "Chiniot",
  "39": "Chishtian",
  "41": "Dadu",
  "43": "Daharki",
  "45": "Daska",
  "47": "Dera Ghazi Khan",
  "49": "Dera Ismail Khan",
  "51": "Faisalabad",
  "53": "Ferozwala",
  "55": "Ghotki",
  "57": "Gojra",
  "59": "Gujranwala",
  "61": "Gujranwala Cantonment",
  "63": "Gujrat",
  "65": "Hafizabad",
  "67": "Haroonabad",
  "69": "Hasilpur",
  "71": "Hub",
  "73": "Hyderabad",
  "75": "Jacobabad",
  "77": "Jaranwala",
  "79": "Jatoi",
  "81": "Jhang",
  "83": "Jhelum",
  "85": "Kabal",
  "87": "Kamalia",
  "89": "Kamber Ali Khan",
  "91": "Kāmoke",
  "93": "Kandhkot",
  "95": "Kasur",
  "97": "Khairpur",
  "99": "Khanewal",
  "101": "Khanpur",
  "103": "Khushab",
  "105": "Khuzdar",
  "107": "Kohat",
  "109": "Kot Abdul Malik",
  "111": "Kot Addu",
  "113": "Kotri",
  "115": "Larkana",
  "117": "Layyah",
  "119": "Lodhran",
  "121": "Mandi Bahauddin",
  "123": "Mansehra",
  "125": "Mardan",
  "127": "Mianwali",
  "129": "Mingora",
  "131": "Mirpur",
  "133": "Mirpur Khas",
  "135": "Mirpur Mathelo",
  "137": "Multan",
  "139": "Muridke",
  "141": "Muzaffarabad",
  "143": "Muzaffargarh",
  "145": "Narowal",
  "147": "Nawabshah",
  "149": "Nowshera",
  "151": "Okara",
  "153": "Pakpattan",
  "155": "Quetta",
  "157": "Rahim Yar Khan",
  "159": "Sadiqabad",
  "161": "Sahiwal",
  "163": "Sambrial",
  "165": "Samundri",
  "167": "Sargodha",
  "169": "Shahdadkot",
  "171": "Sheikhupura",
  "173": "Shikarpur",
  "175": "Sialkot",
  "177": "Sukkur",
  "179": "Swabi",
  "181": "Tando Adam",
  "183": "Tando Allahyar",
  "185": "Tando Muhammad Khan",
  "187": "Taxila",
  "189": "Turbat",
  "191": "Umerkot",
  "193": "Vehari",
  "195": "Wah Cantonment",
  "197": "Wazirabad",
  "101": ""
};

export const CATEGORIES = {
  "1": "Action Figures",
  "2": "Arts & Crafts",
  "3": "Baby & Toddler Toys",
  "4": "Books",
  "5": "Clothes & Costumes",
  "6": "Toy Guns & Swords",
  "7": "Dolls & Doll Houses",
  "8": "Consoles, Games & Electronics",
  "9": "Games & Puzzles",
  "10": "Kids Furniture",
  "11": "Bicycles & Cars",
  "12": "Learning & Development",
  "13": "LEGO Building Blocks & Sets",
  "14": "Musical Instruments",
  "15": "Others",
  "16": "Outdoor Toys",
  "17": "Preshool Toys & Activities",
  "18": "Toy Cars & RC",
  "19": "Playsets",
  "20": "Stuffed Toys",
};

export const CATEGORY_IMAGES = {
  "1": "action_figures.png",
  "2": "arts_crafts.png",
  "3": "baby_toddler_toys.png",
  "4": "books_comics_manga.png",
  "5": "clothes_costumes.png",
  "6": "toys_guns_swords.png",
  "7": "dolls_doll_houses.png",
  "8": "consoles_games_elelectronics.png",
  "9": "games_puzzles.png",
  "10": "kids_furniture.png",
  "11": "bicycles_cars.png",
  "12": "learning_development.png",
  "13": "lego_building_blocks.png",
  "14": "musical_instruments.png",
  "15": "others.png",
  "16": "outdoor_toys.png",
  "17": "school_supplies.png",
  "18": "toy_cars.png",
  "19": "playsets.png",
  "20": "stuffed_toys.png",
};